/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-26T15:10:34-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-05T13:59:48-07:00
*/



import React, { Component } from 'react';
import Avatar from '../../common/Avatar';
import Button from '../../blocks/Button';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Link } from 'react-router';
import { dimensions, spacing, type, borders, color, textColor, size } from '../../../style';
import { tsYears } from '../../../common';

const style = StyleSheet.create({
  item: {
    ...textColor.DARKER,
    display: 'flex',
    alignItems: 'center',
    ...spacing.PADDING_MD,
    borderBottom: borders.DEFAULT,

    [dimensions.SCREEN_MIN_MD]: {
      ':hover': {
        backgroundColor: color.GREY_LIGHTEST
      }
    },

    [dimensions.SCREEN_MAX_SM]: {
      ...spacing.PADDING_SM
    }
  },

  resultThumb: {
    ...spacing.MARGIN_RIGHT_MD,
    flex: '0 0 70px'


  },
  title: {
    ...type.title.XS
  },

  resultActions: {
    [dimensions.SCREEN_MAX_SM]: {
      left: '88px',
      position: 'relative'
    }
  },
  meta: {
    ...type.SM,
    ...textColor.NORMAL
  }
});

class BlockedUser extends Component {

  render () {

    return (
      <Link className={css(style.item)} to={`/~${this.props.title}`}>
        <div className={css(style.resultThumb)}>
          <Avatar src={this.props.avatar} />
        </div>
        <div className={css(style.resultDetails)}>
          <div className={css(style.title)}>{this.props.title}</div>
          <div className={css(style.meta)}>{this.props.age} ･ {this.props.city}, {this.props.region}, {this.props.country}</div>
        </div>
      </Link>
  )};
}



export default BlockedUser;



// WEBPACK FOOTER //
// ./src/components/pages/Settings/BlockedUser.jsx